<template>
	<div class="wrapper" style="margin-top: 5rem">
		<b-container>
			<!-- 大奖周 -->
			<!-- <div class="box-wrap" style="margin-top: 10rem">
				<div class="title">{{content.title}}</div>
				<div class="text-content" v-html="content.content" style=""> -->
					<!-- <p style="margin: 0; line-height: 2rem">
						2021未来科学大奖周系列活动将于11月16日-21日在北京举办，为期六天。
					</p>
					<p style="margin: 0; line-height: 2rem">
						主要活动包括：<b style="color: #010824"
							>获奖者学术报告会：</b
						>由生命科学、物质科学、数学与计算机科学三大奖项获奖人阐述其获奖成果；<b
							style="color: #010824"
							>青少年对话获奖者:</b
						>为更多热爱科学的青少年提供一个与科学家面对面交流的机会，激励未来一代走上科学研究和科研创新之路；<b
							style="color: #010824"
							>未来科学大奖颁奖典礼：</b
						>表彰为全人类做出重大科研成果的科学家，共同见证获奖人的荣耀时刻；<b
							style="color: #010824"
							>科学峰会：</b
						>由世界知名科学家分享前沿科学成果，共同探讨学术创新，共襄科学盛举。
					</p>
					<p style="margin: 0; line-height: 2rem">
						科学改变未来，以科学精神影响大中华区、影响世界、影响下一代。
					</p> -->
				<!-- </div>
			</div> -->
			<!-- 议程 -->
			<div id="agenda" class="box-wrap">
				<div class="title" style="margin-bottom: 1.2rem">{{tableTitle.title}}</div>
				<div
					style="color: #808080; font-size: 0.67rem;word-spacing: 2em;letter-spacing: 2px;"
				>
					{{tableTitle.subTitle}}
				</div>
				<div
					class="agenda-table"
					style="margin-top: 3.7rem"
					v-for="(item, index) in agendaDataList"
					:key="index"
				>
					<b-tabs
						content-class="mt-3"
						justified
						active-nav-item-class="hehe"
					>
						<b-tab
							v-for="(agendaItem, ind) in item"
							:key="ind"
							:active="ind == 0 ? true : false"
							@click="clickTab(agendaItem.tables)"
						>
							<div slot="title">
								<div>{{agendaItem.date}}</div>
								<div style="margin-top: 2rem">
									<div v-for="(titItem, key) in agendaItem.tables.map(item => { return item.shortTit })" :key="key">
										{{titItem}}
										<div v-if="agendaItem.tables.map(item => { return item.title }).length > 1 &&
											 key !== agendaItem.tables.map(item => { return item.title }).length-1">---</div>
									</div>
								</div>
							</div>
							<div
								class="agenda-wrap"
								v-for="(tableItem, tableIndex) in agendaData"
								:key="tableIndex"
							>
								<div
									style="color: #000823; font-size: 1.3rem; margin: 1.2rem 5.2rem; font-weight: 600;"
								>
									{{ tableItem.title }}
								</div>
								<div
									style="color: #808080; font-size: 0.76rem;"
								>
									{{ tableItem.subTitle }}
								</div>
								<agendaTable
									:table="tableItem.table"
								></agendaTable>
							</div>
						</b-tab>

						<!-- <b-tab title="Second"><div>33333</div></b-tab>
                        <b-tab title="Second"><div>33333</div></b-tab>
                        <b-tab title="Second"><div>33333</div></b-tab>
                        <b-tab title="Very, very long title"><div >33333</div></b-tab> -->
					</b-tabs>
				</div>
			</div>
			<!-- 人物列表 -->
			<div
				id="academic_guidance"
				class="box-wrap"
				style="display: flex; justify-content: space-around"
			>
				<div style="text-align: center">
					<div class="committe-tit">Steering Committee</div>
					<template v-for="(item, index) in steePersonList">
						<div
							style="color: #808080; font-size: 0.8rem; margin: 0.3rem 0;"
							:key="index"
						>
							{{ item }}
						</div>
					</template>
				</div>
				<div style="text-align: center">
					<div class="committe-tit">Program Committee</div>
					<template v-for="(item, index) in programPersonList">
						<div
							style="color: #808080; font-size: 0.8rem; margin: 0.3rem 0;"
							:key="index"
						>
							{{ item }}
						</div>
					</template>
				</div>
			</div>
		</b-container>
	</div>
</template>
<script>
import zh from '@/common/xdata/zh';
import en from '@/common/xdata/en';
import cuTable from '@/components/cuTable.vue';
import agendaTable from '@/components/agendaTable.vue';

export default {
	components: { cuTable, agendaTable },
	
	data() {
		return {
			tableTitle: {},
			bg: false,
			steePersonList: [
				'丛京生',
				'丁洪',
				'林建华',
				'田刚',
				'武向平',
				'谢晓亮',
			],
			programPersonList: [
				'励建书（联席主席）',
				'骆利群（联席主席）',
				'陈恂',
				'邓锋',
				'丁健',
				'何川',
				'李明',
				'李凯',
				'林海帆',
				'刘小乐',
				'王晓东',
				'张寿武',
				'张晓东',
			],
			futureInfo: '',
			current: 0,
			dateList: [],
			contactList: {},
			partnerList: [],
			meetingData: {},
			donorProjectList: [],
			year: '',
			agendaDataList: [],
			// agendaDataList: [
			// 	[
			// 		{
			// 			date: '11月16日',
			// 			tables: [
			// 				{
			// 					title: '2021未来科学大奖获奖者学术报告会',
			// 					subTitle: '（举办时间及具体时间待定）',
			// 				},
			// 			],
			// 		},
			// 	],
			// 	[
			// 		{
			// 			date: '11月19日',
			// 			tables: [
			// 				{
			// 					title: '2021未来科学大奖获奖者学术报告会',
			// 					subTitle: '（举办时间及具体时间待定）',
			// 					table: [
			// 						{
			// 							arr: [
			// 								{
			// 									time: '08:30 - 09:00',
			// 									content: {
			// 										title: '',
			// 										describe: {
			// 											class:
			// 												'2021未来科学大奖周开幕仪式',
			// 											personIntro: '',
			// 										},
			// 									},
			// 								},
			// 							],
			// 							text:
			// 								'【生命科学】RNA生物学，未来医疗新方向（Session Chair 何川）',
			// 						},
			// 						{
			// 							arr: [
			// 								{
			// 									time: '08:30 - 09:00',
			// 									content: {
			// 										title: '演讲主旨1',
			// 										describe: {
			// 											class: '',
			// 											personIntro:
			// 												'何川，芝加哥大学讲座教授，美国霍华德·休斯医学研究所研究员，未来科学大奖科学委员会委员 ',
			// 										},
			// 									},
			// 								},
			// 								{
			// 									time: '09:00 - 10:10',
			// 									content: {
			// 										title: '演讲主旨2',
			// 										describe: {
			// 											class: '',
			// 											personIntro:
			// 												'付向东，美国UCSD细胞分子医学教授',
			// 										},
			// 									},
			// 								},
			// 							],
			// 							text: '【物理】（Session Chair 丁洪）',
			// 						},
			// 					],
			//                 },
			//                 {
			// 					title: '2021未来科学大奖获奖者学术报告会',
			// 					subTitle: '（举办时间及具体时间待定）',
			// 					table: [
			// 						{
			// 							arr: [
			// 								{
			// 									time: '08:30 - 09:00',
			// 									content: {
			// 										title: '',
			// 										describe: {
			// 											class:
			// 												'2021未来科学大奖周开幕仪式',
			// 											personIntro: '',
			// 										},
			// 									},
			// 								},
			// 							],
			// 							text:
			// 								'【生命科学】RNA生物学，未来医疗新方向（Session Chair 何川）',
			// 						},
			// 						{
			// 							arr: [
			// 								{
			// 									time: '08:30 - 09:00',
			// 									content: {
			// 										title: '演讲主旨1',
			// 										describe: {
			// 											class: '',
			// 											personIntro:
			// 												'何川，芝加哥大学讲座教授，美国霍华德·休斯医学研究所研究员，未来科学大奖科学委员会委员 ',
			// 										},
			// 									},
			// 								},
			// 								{
			// 									time: '09:00 - 10:10',
			// 									content: {
			// 										title: '演讲主旨2',
			// 										describe: {
			// 											class: '',
			// 											personIntro:
			// 												'付向东，美国UCSD细胞分子医学教授',
			// 										},
			// 									},
			// 								},
			// 							],
			// 							text: '【物理】（Session Chair 丁洪）',
			// 						},
			// 					],
			// 				},
			// 			],
			// 		},
			// 		{
			// 			date: '11月17日',
			// 			title: '2021未来科学大奖获奖者学术报告会',
			// 			subTitle: '（举办时间及具体时间待定）',
			// 			table: [],
			// 		},
			// 		{
			// 			date: '11月18日',
			// 			title: '2021未来科学大奖获奖者学术报告会',
			// 			subTitle: '（举办时间及具体时间待定）',
			// 			table: [],
			// 		},
			// 		{
			// 			date: '11月19日',
			// 			title: '2021未来科学大奖获奖者学术报告会',
			// 			subTitle: '（举办时间及具体时间待定）',
			// 			table: [],
			// 		},
			// 		{
			// 			date: '11月20日',
			// 			title: '2021未来科学大奖获奖者学术报告会',
			// 			subTitle: '（举办时间及具体时间待定）',
			// 			table: [],
			// 		},
			// 	],
			// ],
			//议程总数据
			agendaData: [], //当前议程数据
			content: {},
		}
	},
	watch:{
		$route:{
			handler(to, from){
				if(to.query.lang == 'en'){
					this.langmode(en)
					this.clickTab(this.agendaDataList[0][0].tables)
				}else{
					this.langmode(zh)
					this.clickTab(this.agendaDataList[0][0].tables)
				}
				
			},
			immediate: true
		}
	},
	created() {

		this.year = this.$route.query.year
		if (this.year) {
			localStorage.setItem('BIGWEEKYEAR', this.year)
		} else {
			localStorage.getItem('BIGWEEKYEAR')
		}
		
	},
	mounted() {
		this.year = localStorage.getItem('BIGWEEKYEAR')
	},
	methods: {
		langmode(obj){
			this.steePersonList = obj.steePersonList
			this.programPersonList = obj.programPersonList
			this.tableTitle = obj.text
			this.agendaDataList = obj.agendaDataList
			this.content = obj.context
		},
		clickTab(tables) {
			if (tables.length !== 0) {
				tables.forEach((item) => {
					console.log(item.table)
					if (item.table.length !== 0) {
						item.table[0].bg = item.table[0].text ? true : false
					}
				})
			}
			this.agendaData = tables
		},
		//处理日期格式
		formarDate(date) {
			let arr = date.split('-')
			let dateInstance = new Date(
				Number(arr[0]),
				Number(arr[1]),
				Number(arr[2])
			)
			console.log(this.weekday()[dateInstance.getDay()])
			// if(this.i18n.locale='cn'){
			return `${Number(arr[1])}月 ${Number(arr[2])}日 ${
				this.weekday()[dateInstance.getDay()]
			}`
			// }else{
			//     return dateInstance.split(' ').splice(0, 3).join(' ')
			// }
		},
		weekday() {
			let weekday = []
			weekday[0] = '星期日'
			weekday[1] = '星期一'
			weekday[2] = '星期二'
			weekday[3] = '星期三'
			weekday[4] = '星期四'
			weekday[5] = '星期五'
			weekday[6] = '星期六'
			return weekday
		},
		//换行符号
		turn(data) {
			return data.replace(/(\r\n|\n|\r)/gm, '<br />')
		},
		//学术指导
		getDonorProject(year) {
			this.$api
				.donorProject({
					projectId: year,
				})
				.then((res) => {
					let arrKey = Object.keys(res.data)
					let arrValue = Object.values(res.data)
					this.donorProjectList = arrValue.map((item, index) => {
						return {
							name: arrKey[index],
							value: item,
						}
					})
					console.log(
						'---------学术指导----------------------',
						this.donorProjectList
					)
				})
		},
		//大奖周概述
		getFutureInfo(year) {
			this.$api
				.futureProject({
					projectId: year,
				})
				.then((res) => {
					console.log(res.data)
					this.futureInfo = res.data.futureSummary
				})
		},
		//参会报名
		meetingInvite(year) {
			this.$api
				.getPrizeMeetings({
					projectId: year,
				})
				.then((res) => {
					console.log('参会报名', res.data)
					this.meetingData = res.data
					console.log(this.meetingData.hotelList[0].nape)
				})
		},
		//合作伙伴
		getPrizeContact(year) {
			this.$api
				.getPrizeContact({
					projectId: year,
				})
				.then((res) => {
					console.log('联系我们', res.data)
					this.contactList = res.data
				})
		},

		//议程
		getAgendData(year) {
			this.$api
				.getAgendList({
					projectId: year,
				})
				.then((res) => {
					console.log('议程', res.data)
					this.dateList = Object.keys(res.data).map((item) => {
						let arr = item.split('-')
						arr.splice(0, 1)
						return arr.join('.')
					})
					this.agendaDataList = Object.values(res.data)
					this.agendaData = this.agendaDataList[0]
				})
		},
		//合作伙伴
		getPartners(year) {
			this.$api
				.getPartnerList({
					projectId: year,
				})
				.then((res) => {
					console.log('战略伙伴', res.data)
					let keysArr = Object.keys(res.data)
					let valuesArr = Object.values(res.data)
					this.partnerList = keysArr.map((item, index) => {
						return {
							name: item,
							value: valuesArr[index],
						}
					})
				})
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper {
	//word-spacing: 2em;
	letter-spacing: 2px;
	.box-wrap::v-deep {
		text-align: center;
		width: 82%;
		margin: 6rem auto;
		.text-content {
			color: #757575;
			text-align: center;
			font-size: 0.8rem;
			word-spacing: 2px;
			text-indent: 2em;
		}
		.title {
			color: #666666;
			font-size: 2.3rem;
			margin-bottom: 1.6rem;
			font-weight: 600;
		}

		.nav-tabs .nav-link {
			color: #010824;
			border: 0.5px solid #808080;
			border-radius: 0;
			background: #e5e5e5;
			margin-right: -1px;
			height: 100%;
			padding: 1rem;
		}
		.nav-link.active.hehe {
			color: #fff;
			border: 0.5px solid #010824;
			background-color:#11206f;
		}
		.tab-content.mt-3 {
			margin-top: 0 !important;
			padding-top: 1rem;
			padding-bottom: 0.6rem;
			border-left: 0.5px solid #808080;
			border-right: 0.5px solid #808080;
			border-bottom: 0.5px solid #808080;
			margin-right: -1px;
		}
		.committe-tit {
			margin: 2rem 0;
			font-size: 1.6rem;
			color: #000823;
			font-weight: 500;
			word-spacing: 0;
			letter-spacing: 0;
		}
	}
}
@media (max-width: 768px) {
	.wrapper {
		font-size: 1rem;
		.box-wrap::v-deep {
			width: 100%;
			.text-content {
				font-size: 1rem;
			}
		}
	}
}
</style>
